<mat-radio-group [formControl]="control">
  <mat-radio-button [value]="1" *ngIf="!migration">
    {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/account-type/add' | translate }}
  </mat-radio-button>
  <mat-radio-button [value]="2" *ngIf="migration">
    {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/account-type/migrate' | translate }}
  </mat-radio-button>
</mat-radio-group>
<div class="step-actions">
  <button mat-raised-button color="primary" matStepperNext>{{ 'next' | translate }}</button>
</div>
